import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SetupTab } from 'areas/shared/pages/setup';
import { TextAreaBox, Switch, IntBox } from 'fw/forms';
import { Label, ActionButton } from 'fw/components';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import { CommentsGrid } from 'areas/shared/components';
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel'
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';

class EmployeeAndComp extends SetupTab {
    initialForm() {
        return {
            siteReviewEmployeeAndCompId: "",
            certificationId: "",
            certificationKey: "",
            amountFullTimeEmployee: 0,
            amountPartTimeEmployee: 0,
            amountContractor: 0,
            amountTemporaryEmployee: "",
            amountTotalEmployee: 0,
            doHiringFiring: false,
            hiringProcedure: "",
            firingProcedure: "",
            isHighestPaid: false,
            highestPaidDetail: "",
            rowVersion: null,
            comments: null,
            reviewComment: ''
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getEmployeeAndComp'),
            save: API.Admin.url('/siteReview/saveEmployeeAndComp')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
        }
    }

    saveRequest() {
        return {
            siteReviewEmployeeAndCompId: this.state.form.siteReviewEmployeeAndCompId,
            certificationId: this.state.form.certificationId,
            certificationKey: this.props.selectedId,
            amountFullTimeEmployee: this.state.form.amountFullTimeEmployee,
            amountPartTimeEmployee: this.state.form.amountPartTimeEmployee,
            amountContractor: this.state.form.amountContractor,
            amountTemporaryEmployee: +this.state.form.amountTemporaryEmployee,
            amountTotalEmployee: +this.state.form.amountTemporaryEmployee + this.state.form.amountFullTimeEmployee + this.state.form.amountPartTimeEmployee + this.state.form.amountContractor,
            doHiringFiring: this.state.form.doHiringFiring,
            hiringProcedure: this.state.form.hiringProcedure,
            firingProcedure: this.state.form.firingProcedure,
            isHighestPaid: this.state.form.isHighestPaid,
            highestPaidDetail: this.state.form.highestPaidDetail,
            rowVersion: this.state.form.rowVersion,
            reviewStatus: this.state.form.reviewStatus,
            reviewComment: this.state.reviewComment
        }
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    ready = () => {
        // If slected form is paper -> Redirect to FinalRecomm
        if (this.state.form.isPaperForm)
            window.location.href = `/admin/siteReview/${this.props.selectedId}/finalRecomm/${this.props.queueTypeCode}`;
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form["reviewStatus"] = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    blankIsHighestPaid = () => {
        let form = this.state.form;

        if (form.isHighestPaid)
            form.highestPaidDetail = null;

        this.updatePostData(form, true);
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewEmployeeAndCompReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    isValidated(data) {
        return data.isSubmitted;
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'SEC'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'SEC'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3>
                            {this.state.form.siteReviewTitle}
                            {this.renderAdminStepToolbar()}
                            <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                        </h3>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        {this.state.form.hasBusinessStructure ?
                            <React.Fragment>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Number of Full-Time Employees</Label>
                                            <IntBox disabled positiveOnly maxLength={9} name="amountFullTimeEmployee" style={{ width: 110 }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Number of Part-Time Employees</Label>
                                            <IntBox disabled positiveOnly maxLength={9} name="amountPartTimeEmployee" style={{ width: 110 }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Number of Contractor or 1099 Employees</Label>
                                            <IntBox disabled positiveOnly maxLength={9} name="amountContractor" style={{ width: 110 }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Number of Temporary Employees</Label>
                                            <IntBox
                                                positiveOnly
                                                maxLength={9}
                                                name="amountTemporaryEmployee"
                                                placeholder="# Temporary"
                                                style={{ width: 110 }} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Total Number of Employees</Label>
                                            <IntBox disabled positiveOnly maxLength={9} value={+this.state.form.amountTemporaryEmployee + this.state.form.amountContractor + this.state.form.amountFullTimeEmployee + this.state.form.amountPartTimeEmployee} style={{ width: 110 }} />
                                        </FormGroup>
                                    </Col>
                                    <Col md={5}>
                                        <FormGroup>
                                            <Label htmlFor="doHiringFiring">Do you do the Hiring and Firing?</Label>
                                            <Switch name="doHiringFiring" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Please explain your Company's Hiring procedures...</Label>
                                            <TextAreaBox
                                                required
                                                name="hiringProcedure"
                                                placeholder="Please explain your Company's Hiring procedures..."
                                                maxLength={500}
                                                rows={3} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label required>Please explain your Company's Firing procedures...</Label>
                                            <TextAreaBox
                                                required
                                                name="firingProcedure"
                                                placeholder="Please explain your Company's Firing procedures..."
                                                maxLength={500}
                                                rows={3} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label htmlFor="isHighestPaid">Are you the highest paid person in the Company?</Label>
                                            <Switch onChange={this.blankIsHighestPaid} name="isHighestPaid" labelLeft="No" labelRight="Yes" bsStyle="success" />
                                        </FormGroup>
                                        {!this.state.form.isHighestPaid ?
                                            (
                                                <FormGroup>
                                                    <Label required>Why not, and who is (Please explain in detail)?</Label>
                                                    <TextAreaBox
                                                        required
                                                        name="highestPaidDetail"
                                                        placeholder="Please explain..."
                                                        maxLength={500}
                                                        rows={3} />
                                                </FormGroup>
                                            ) : null}
                                    </Col>
                                </Row>
                            </React.Fragment>
                            :
                            <Row>
                                <Col md={12}>
                                    <h4 style={{ color: 'red' }}><u>Attention!</u> Certification's step "Business Structure" must be completed in order to review this section</h4>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>

                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={this.state.form.comments}
                        documents={this.state.form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"SEC"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={this.state.form.entityId}
                        readonly={!this.state.privileges.edit || !this.state.enabled || !this.state.form.hasBusinessStructure}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange} />
                </Row>
                {this.state.form.showComplete ?
                    <Row>
                        <ReviewPanel stepName="Employee & Compensation"
                            onChange={this.handleReviewStatus} reviewStatus={this.state.form.reviewStatus} />
                    </Row>
                : null}
            </React.Fragment>
        )
    }
}

export default EmployeeAndComp;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/employeeAndComp/EmployeeAndComp.js